import React from 'react'
import './Midias.css'

const Midias = () => {
  const events = [
    {
      title: 'Jornada Anual ASJF 2025',
      date: '12 de janeiro de 2025',
      description: 'Um encontro de membros, associados e convidados para debater projetos da associação, direitos trabalhistas e ações sociais.',
      img: '/evento1.jpg',
      action: 'Ver detalhes',
    },
    {
      title: 'Fórum de Liderança ASJF',
      date: '24 de março de 2025',
      description: 'Painéis e workshops para capacitação de lideranças sindicais e comunitárias dentro da Justiça Federal.',
      img: '/evento2.jpg',
      action: 'Assistir vídeo',
    },
    {
      title: 'Ação Social do Aniversário',
      date: '14 de julho de 2025',
      description: 'Evento anual de arrecadação e doação para a comunidade, com participação de associados e parceiros.',
      img: '/evento3.jpg',
      action: 'Galeria de fotos',
    },
    {
      title: 'Encontro de Voluntários',
      date: '10 de novembro de 2025',
      description: 'Reunião de planejamento das ações voluntárias da ASJF para o próximo ano, com debate de metas e cronograma.',
      img: '/evento4.jpg',
      action: 'Saiba mais',
    },
  ]

  return (
    <main className="midiasPage">
      <div className="midiasContent">
        <section className="midiasIntro">
          <span>Mídias</span>
          <h1>Eventos anuais da ASJF</h1>
          <p>
            Veja alguns dos principais eventos promovidos pela ASJF ao longo do ano, com registros de atividades,
            workshops e ações sociais para a comunidade.
          </p>
        </section>

        <section className="midiasGrid">
          {events.map((event) => (
            <article key={event.title} className="eventCard">
              <div className="eventPhoto">
                <img src={event.img} alt={event.title} />
              </div>
              <div className="eventContent">
                <div className="eventHeader">
                  <h2>{event.title}</h2>
                  <span className="eventDate">{event.date}</span>
                </div>
                <p className="eventDescription">{event.description}</p>
                <div className="eventActions">
                  <a href="#">{event.action}</a>
                </div>
              </div>
            </article>
          ))}
        </section>
      </div>
    </main>
  )
}

export default Midias
